import { ApprovalDocumentAdvancedSearchType } from '.';
import { types, Actions } from './actions';

const initialState: ApprovalDocumentAdvancedSearchType = {
  advancedSearchSettings: [],
};

const reducer = (state = initialState, actions: Actions): ApprovalDocumentAdvancedSearchType => {
  const newState = { ...state };
  switch (actions.type) {
    case types.SAVE_ADVANCED_SEARCH_SETTINGS:
      newState.advancedSearchSettings = actions.payload;
      return newState;
    case types.CLEAR_ADVANCED_SEARCH_SETTINGS:
      newState.advancedSearchSettings = actions.payload;
      return newState;
    default:
      return state;
  }
};

export default reducer;
